import { useContractFunction } from "@usedapp/core";
import { Contract } from "ethers";
import * as StakeAbi from "../abis/stakeContract.json"
//import * as MasterAbi from "../abis/masterStakeContract.json"
//reinvestTokens

export function useDepositAction(contractAddress:any){
    const contract = new Contract(contractAddress, StakeAbi.abi);
    const {state, send, events} = useContractFunction(contract, 'stakeTokens', {transactionName: "Deposit Stake"});
    return {state, send, events};
}

export function useWithdrawAction(contractAddress:any){
    const contract = new Contract(contractAddress, StakeAbi.abi);
    const {state, send, events} = useContractFunction(contract, 'withdrawStake', {transactionName: "Withdraw Stake"});
    return {state, send, events};
}

export function useUnStakeAllAction(contractAddress:any){
    const contract = new Contract(contractAddress, StakeAbi.abi);
    const {state, send, events} = useContractFunction(contract, 'unstakeAll', {transactionName: "Withdraw Stake"});
    return {state, send, events};
}

//usesendCompoundAction
export function useCompoundAction(contractAddress:any){
    const contract = new Contract(contractAddress, StakeAbi.abi);
    const {state, send, events} = useContractFunction(contract, 'reinvestTokens', {transactionName: "Reinvest Compound"});
    return {state, send, events};
}

